function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import Modal from './Modal';
import styles from './InputModal.module.scss';
import { FocusTrap, Text, TextInput } from '@mantine/core';
import ErrorNotice from './ErrorNotice';
export function DefaultInput(_param) {
    var value = _param.value, error = _param.error, setValue = _param.setValue, props = _object_without_properties(_param, [
        "value",
        "error",
        "setValue"
    ]);
    return /*#__PURE__*/ _jsx(TextInput, _object_spread({
        "data-1p-ignore": true,
        "data-autofocus": true,
        size: "md",
        variant: "filled",
        error: !(error == null),
        classNames: {
            input: styles.input
        },
        value: value !== null && value !== void 0 ? value : '',
        onChange: function(param) {
            var value = param.target.value;
            return setValue(value);
        }
    }, props));
}
export default function InputModal(param) {
    var isOpen = param.isOpen, title = param.title, description = param.description, submitText = param.submitText, _param_submitOnValid = param.submitOnValid, submitOnValid = _param_submitOnValid === void 0 ? false : _param_submitOnValid, onClose = param.onClose, renderInput = param.renderInput, onSubmit = param.onSubmit, validPredicate = param.validPredicate;
    var _React_useState = _sliced_to_array(React.useState(null), 2), error = _React_useState[0], setError = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState(''), 2), value = _React_useState1[0], setValue = _React_useState1[1];
    var _React_useState2 = _sliced_to_array(React.useState(false), 2), loading = _React_useState2[0], setLoading = _React_useState2[1];
    var valid = validPredicate != null ? validPredicate(value) : true;
    React.useEffect(function() {
        if (!isOpen) {
            setValue('');
            setError(null);
        }
    }, [
        isOpen,
        value
    ]);
    var handleComplete = React.useCallback(/*#__PURE__*/ _async_to_generator(function() {
        var error;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    setLoading(true);
                    return [
                        4,
                        onSubmit(value)
                    ];
                case 1:
                    _state.sent();
                    onClose();
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    if (_instanceof(error, Error)) {
                        setError(error.message);
                    } else {
                        setError('An unknown error occurred.');
                    }
                    setLoading(false);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    }), [
        onClose,
        value,
        onSubmit
    ]);
    React.useEffect(function() {
        if (submitOnValid && valid) {
            handleComplete();
        }
    }, [
        valid,
        handleComplete,
        submitOnValid
    ]);
    React.useEffect(function() {
        var handleKeyDown = function handleKeyDown(event) {
            if (event.key === 'Enter' && valid) {
                handleComplete();
            }
        };
        if (!isOpen) {
            return;
        }
        document.addEventListener('keydown', handleKeyDown);
        return function() {
            return document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        valid,
        handleComplete,
        isOpen
    ]);
    return /*#__PURE__*/ _jsx(Modal, {
        isOpen: isOpen,
        title: title,
        loading: loading,
        onClose: onClose,
        onExitTransitionEnd: function() {
            return setLoading(false);
        },
        onConfirm: handleComplete,
        confirmText: submitText,
        canConfirm: valid,
        children: /*#__PURE__*/ _jsxs("div", {
            className: styles.inputModalDescription,
            children: [
                typeof description === 'string' ? /*#__PURE__*/ _jsx(Text, {
                    className: styles.inputModalDescriptionText,
                    children: description
                }) : description,
                typeof renderInput === 'function' ? /*#__PURE__*/ _jsxs(React.Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(FocusTrap, {
                            active: isOpen,
                            children: renderInput({
                                value: value,
                                error: error,
                                setValue: setValue,
                                setError: setError
                            })
                        }),
                        error != null ? /*#__PURE__*/ _jsx(ErrorNotice, {
                            children: error
                        }) : null
                    ]
                }) : null
            ]
        })
    });
}
